module.exports = __webpack_public_path__ + "static/media/account.e44aac42.png";